import { Component, Input, OnChanges } from '@angular/core'

export interface CircledIconColors {
  iconColor: string
  backgroundColor: string
}

@Component({
  selector: 'basin-circled-icon',
  templateUrl: './circled-icon.component.html',
  styleUrls: ['./circled-icon.component.scss'],
})
export class CircledIconComponent implements OnChanges {
  @Input() size: string = 'medium'
  @Input() icon: string
  @Input() theme: string
  @Input() iconColor: string = 'var(--neutral-color-true-white)'
  @Input() backgroundColor: string = 'var(--primary-color)'
  @Input() styleClass: string
  circleClass: string
  iconClass: string

  ngOnChanges(): void {
    this.setClass()
  }

  setClass(): void {
    this.circleClass = `circle basin-radius-rounded ${this.size} ${this.styleClass}`

    this.iconClass = `icon ${this.icon}`
  }

  getThemeColors(): CircledIconColors {
    switch (this.theme) {
      case 'yellow':
      case 'warning':
        return {
          iconColor: 'var(--stantec-true-white)',
          backgroundColor: 'var(--warning-color)',
        }
      case 'green':
      case 'success':
        return {
          iconColor: 'var(--stantec-true-white)',
          backgroundColor: 'var(--success-color)',
        }
      case 'blue':
      case 'info':
        return {
          iconColor: 'var(--stantec-true-white)',
          backgroundColor: 'var(--info-color)',
        }
      case 'orange':
      case 'primary':
        return {
          iconColor: 'var(--stantec-true-white)',
          backgroundColor: 'var(--primary-color)',
        }
      case 'inverse-yellow':
      case 'inverse-warning':
        return {
          iconColor: 'var(--warning-color-text-links)',
          backgroundColor: 'var(--warning-color-25)',
        }
      case 'inverse-green':
      case 'inverse-success':
        return {
          iconColor: 'var(--success-color-text-links)',
          backgroundColor: 'var(--success-color-15)',
        }
      case 'inverse-blue':
      case 'inverse-info':
        return {
          iconColor: 'var(--info-color-text-links)',
          backgroundColor: 'var(--info-color-15)',
        }
      case 'inverse-orange':
      case 'inverse-primary':
        return {
          iconColor: 'var(--primary-color)',
          backgroundColor: 'var(--primary-color-25)',
        }
      default:
        return {
          iconColor: this.iconColor,
          backgroundColor: this.backgroundColor,
        }
    }
  }
}
